module.exports = __webpack_public_path__ + "static/media/Unown_gaussian2.0c1b44b0.png";